module.exports = __webpack_public_path__ + "img/20161119_104802-1.310817fc.jpg";